import React, {useState, useEffect, useCallback} from "react";
import {IconButton, Menu, MenuItem, Avatar, TextField, Grid} from "@mui/material";
import NotificationsNoneIcon from "@mui/icons-material/NotificationsNone";
import SearchIcon from "@mui/icons-material/Search";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import {ToastContainer} from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import MobileMenuButton from "../General/MobileMenu";
import {getClientByClient_Identity, getClientServiceRequestsDetailsByClientID} from "../../utilities/ClientApi";
import keycloak from "../../Keycloak";
import "./General.css";
import {useClient} from "../../utilities/ClientProvider";

export let clientId = localStorage.getItem('serviceRequestListSelectedClientId');
export let serviceRequestId = localStorage.getItem('serviceRequestListSelectedServiceRequestId');
export let totalHours;
export let hoursUsed;

const Header = () => {
    const [width, setWidth] = useState(window.innerWidth);
    const [showClientServiceRequestsFilter, setClientServiceRequestsFilter] = useState(false);
    const [clientServiceRequestDetails, setClientServiceRequestDetails] = useState([]);
    const [selectedClient, setSelectedClient] = useState('all');
    const [clients, setClients] = useState([]);
    const {setClient} = useClient(); // Get the setClient function from context

    const fetchClientListData = useCallback(async () => {
        if (keycloak && keycloak.token) {
            try {
                const clientInfo = await getClientByClient_Identity(keycloak.token);
                if (keycloak.hasResourceRole("system_admin")) {
                    const newViewStatus = [
                        {value: "all", label: "All"},
                        ...clientInfo.map(client => ({
                            value: client.clientId,
                            label: client.businessName
                        }))
                    ];
                    setClients(newViewStatus);
                    if (!selectedClient || selectedClient === "all") {
                        setClient(newViewStatus[0].value);
                    }
                } else if (keycloak.hasResourceRole("client_recruiter")
                    || keycloak.hasResourceRole("hr_admin")
                    || keycloak.hasResourceRole("client_user")
                    || keycloak.hasResourceRole("client_admin")
                    || keycloak.hasResourceRole("internal_user")
                    || keycloak.hasResourceRole("account_manager")
                    || keycloak.hasResourceRole("delivery_manager")) {
                    setClients([{value: clientInfo[0].clientId, label: clientInfo[0].businessName}]);
                    setClient(clientInfo[0].clientId);
                }
            } catch (e) {
                console.error("Error fetching job list data:", e);
            }
        }
    }, [setClient, selectedClient]);

    useEffect(() => {
        fetchClientListData();
    }, [fetchClientListData]);

    useEffect(() => {
        const sessionClient = sessionStorage.getItem("selected_client_id");
        if (sessionClient) {
            setSelectedClient(sessionClient);
        }
    }, []);

    const handleClientListChange = (event) => {
        const selectedClientId = event.target.value;
        setSelectedClient(selectedClientId);
        setClient(selectedClientId);

        //Setting clientId in session
        sessionStorage.setItem("selected_client_id", selectedClientId)
    };

    const fetchData = useCallback(async () => {
        try {
            if (window.location.href.includes("/ServiceRequestDashboard")) {
                const clientServiceRequestDetailsData = await getClientServiceRequestsDetailsByClientID(clientId, keycloak.token);
                setClientServiceRequestDetails(clientServiceRequestDetailsData);

                clientServiceRequestDetailsData.forEach(client => {
                    client.serviceRequestBudgetSummaryList.forEach(serviceRequest => {
                        totalHours = serviceRequest.allocatedBudget;
                        hoursUsed = serviceRequest.budgetUsed;
                    });
                });
            }
        } catch (error) {
            console.error("Error fetching service request details:", error);
        }
    }, [setClientServiceRequestDetails]);

    useEffect(() => {
        fetchData();
        setClientServiceRequestsFilter(window.location.href.includes("/ServiceRequestDashboard"));

        const isServiceRequestListPage = window.location.href.includes("/ServiceRequestList");
        if (!isServiceRequestListPage) {
            localStorage.setItem('ClientListDropDownSelectedClientId', '0');
        }

        const handleResize = () => setWidth(window.innerWidth);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, [fetchData]);

    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const handleClick = event => setAnchorEl(event.currentTarget);
    const handleClose = () => setAnchorEl(null);

    const style = {
        "& label.Mui-focused": {
            color: "#FF6600",
        },
        "& .MuiOutlinedInput-root": {
            "&.Mui-focused fieldset": {
                borderColor: "#FF6600",
            },
        },
        '&:hover .MuiInput-underline:before': {
            borderBottomColor: '#FF6600', // Orange underline on hover
        },
        '& .MuiInput-underline:after': {
            borderBottomColor: '#FF6600', // Underline when focused
        },
    };

    const serviceRequestsHandleSearch = async event => {
        const selectedOption = event.target.options[event.target.selectedIndex];
        const jsonData = JSON.parse(selectedOption.getAttribute('data-json'));

        const serviceRequestId = jsonData.SRId;
        const serviceRequestProjectId = jsonData.PId;

        window.location.reload();
        localStorage.setItem('serviceRequestProjectId', serviceRequestProjectId);
        localStorage.setItem('serviceRequestListSelectedServiceRequestId', serviceRequestId);
        localStorage.setItem('serviceRequestListTotalHours', clientServiceRequestDetails.serviceRequestBudgetSummaryList.allocatedBudget);
        localStorage.setItem('serviceRequestListHoursUsed', clientServiceRequestDetails.serviceRequestBudgetSummaryList.budgetUsed);
    };

    const getSelectedServiceRequestId = () => serviceRequestId || '';

    const handleLogout = () => {
        // Clear clientId from session when user logs out
        sessionStorage.removeItem("selected_client_id");

        keycloak.logout();
    };

    const isMobile = width <= 480;

    const renderClientDropdown = () => {
        if (keycloak.hasResourceRole("system_admin")) {
            return (
                <TextField
                    select
                    label="Tenant"
                    value={selectedClient}
                    onChange={handleClientListChange}
                    inputProps={{
                        name: 'clientType',
                        id: 'clientType',
                        'aria-label': 'viewType',
                    }}
                    variant="standard"
                    style={{marginLeft: '2%', marginTop: '7px', width: 'auto'}}
                    sx={{
                        '& select': {
                            textAlign: 'left',
                            paddingLeft: '5px',
                        },
                        ...style,
                    }}

                >
                    {clients.map(option => (
                        <MenuItem key={option.value} value={option.value}>
                            {option.label}
                        </MenuItem>
                    ))}
                </TextField>);
        } else {
            return (
                <TextField
                    label="Tenant"
                    value={clients[0]?.label || ""}
                    variant="standard"
                    InputProps={{
                        readOnly: true,
                    }}
                    style={{
                        marginLeft: '30px',
                        marginTop: '7px',
                        width: 'auto'
                    }}
                    disabled
                />
            );
        }
    };

    const shouldRenderClientDropdown = () => {
        const path = window.location.href;
        const clientDropdownPaths = [
            "/JobsList",
            "/Candidates",
            "/ClientList",
            "/"
        ];
        const excludedPaths = [
            "/ServiceRequestDashboard",
            "/CandidateView",
            "/JobView",
            "/EditClientPage",
            "/ServiceRequest",
            "/ClientPage",
            "/EditServiceRequest",
            "/ProjectDashboard",
            "/StaffMemberListView",
            "/MyCV",
            "/ConsultantList",
            "/ExternalCV",
            "/CVList",
            "/AddCV",
            "/OrgCV",
            "/ApplicationScoring"
        ];

        if (excludedPaths.some(p => path.includes(p))) {
            return false;
        }

        return clientDropdownPaths.some(p => path.includes(p));
    };

    return (
        <nav
            style={{
                backgroundColor: "#FFFFFF",
                border: "1px",
                display: "flex",
                overflow: "hidden",
            }}
            className="navbar navbar-expand-lg navbar-light bg-light"
            data-testid="Nav"
        >
            <ToastContainer theme="colored"/>
            <div
                style={{
                    backgroundColor: "#FFFFFF",
                    border: "1px",
                    display: "flex",
                    overflow: "hidden",
                }}
                className="container-fluid"
                data-testid="toastContainer"
            >
                <div className="navbar-brand">
                    <div className="nav-link" data-testid="navLink">
                        <a href="/">
                            {" "}
                        </a>
                        {isMobile && <MobileMenuButton/>}
                    </div>
                </div>
                <Grid container direction={"row"} alignItems={"center"}>
                    <Grid item xs={6}>
                        {window.location.href.includes("/ServiceRequestDashboard") ? (
                            <Grid container direction={"row"} spacing={1} padding={1} justifyContent={"flex-start"}
                                  alignItems={"flex-end"}>
                                <Grid item xs={2.5}>
                                    <TextField
                                        id={"clientNameTextBox"}
                                        data-testid="clientNameTextBox"
                                        style={{
                                            fontFamily: "poppins",
                                            fontWeight: "42px",
                                            display: showClientServiceRequestsFilter && width > 480 ? "block" : "none",
                                        }}
                                        variant={"standard"}
                                        InputLabelProps={{shrink: true}}
                                        value={clientServiceRequestDetails[0]?.clientName || ""}
                                        disabled
                                    />
                                </Grid>
                                <Grid item xs={5}>
                                    <TextField
                                        id="clientServiceRequests"
                                        data-testid="clientServiceRequestsDropdown"
                                        select
                                        label="SR Details"
                                        style={{
                                            fontFamily: "poppins",
                                            fontWeight: "42px",
                                            display: showClientServiceRequestsFilter && width > 480 ? "block" : "none",
                                        }}
                                        sx={style}
                                        variant="standard"
                                        InputLabelProps={{shrink: true}}
                                        value={getSelectedServiceRequestId()}
                                        onChange={serviceRequestsHandleSearch}
                                    >
                                        {clientServiceRequestDetails.map((data) =>
                                            data.serviceRequestBudgetSummaryList.map((serviceRequest) => (
                                                <MenuItem
                                                    key={serviceRequest.serviceRequestId}
                                                    value={serviceRequest.serviceRequestId.toString()}
                                                    data-json={JSON.stringify({
                                                        SRId: serviceRequest.serviceRequestId,
                                                        PId: serviceRequest.projectId,
                                                    })}
                                                >
                                                    {serviceRequest.serviceRequestName}
                                                </MenuItem>
                                            ))
                                        )}
                                    </TextField>

                                    {/*<TextField*/}
                                    {/*    id={"clientServiceRequests"}*/}
                                    {/*    data-testid="clientServiceRequestsDropdown"*/}
                                    {/*    select*/}
                                    {/*    label={"SR Details"}*/}
                                    {/*    SelectProps={{ native: true }}*/}
                                    {/*    style={{*/}
                                    {/*        fontFamily: "poppins",*/}
                                    {/*        fontWeight: "42px",*/}
                                    {/*        display: showClientServiceRequestsFilter && width > 480 ? "block" : "none"*/}
                                    {/*    }}*/}
                                    {/*    sx={style}*/}
                                    {/*    variant={"standard"}*/}
                                    {/*    InputLabelProps={{ shrink: true }}*/}
                                    {/*    value={getSelectedServiceRequestId()}*/}
                                    {/*    onChange={serviceRequestsHandleSearch}*/}
                                    {/*>*/}
                                    {/*    {clientServiceRequestDetails.map((data) => (*/}
                                    {/*        data.serviceRequestBudgetSummaryList.map((serviceRequest) => (*/}
                                    {/*            <option key={serviceRequest.serviceRequestId} value={serviceRequest.serviceRequestId.toString()} data-json={JSON.stringify({*/}
                                    {/*                SRId: serviceRequest.serviceRequestId,*/}
                                    {/*                PId: serviceRequest.projectId*/}
                                    {/*            })}>*/}
                                    {/*                {serviceRequest.serviceRequestName}*/}
                                    {/*            </option>*/}
                                    {/*        ))*/}
                                    {/*    ))}*/}
                                    {/*</TextField>*/}
                                </Grid>
                                <Grid item xs={4}/>
                            </Grid>
                        ) : (
                            shouldRenderClientDropdown() && renderClientDropdown()
                        )}
                        {window.location.href.includes("/ServiceRequestList") ? (
                            renderClientDropdown()
                        ) : null
                        }
                    </Grid>

                    <Grid item xs={6}>
                        <Grid container className={"navigation-avatar-container"}>
                            <Grid item>
                                <div data-testid="accountInfoOuter" className={"user-information-container"}>
                                    <view className="searchIconCss">
                                        <IconButton data-testid="SearchIcon"
                                                    style={{borderColor: "#FFFFFF", backgroundColor: "#FFFFFF"}}>
                                            <SearchIcon style={{color: "#000000"}}/>
                                        </IconButton>{" "}
                                    </view>

                                    <view className="notiIconCss">
                                        {" "}
                                        <IconButton data-testid="NotificationsNoneIcon"
                                                    style={{borderColor: "#FFFFFF", backgroundColor: "#FFFFFF"}}>
                                            <NotificationsNoneIcon style={{color: "#000000"}}/>
                                        </IconButton>
                                    </view>

                                    <div className="d-inline-flex" data-testid="accountInfo">
                                        {!keycloak.authenticated && (
                                            <button type="button" className="btn btn-outline-dark"
                                                    onClick={() => keycloak.login()}>
                                                Login
                                            </button>
                                        )}

                                        {!!keycloak.authenticated && (
                                            <view className="accountButton">
                                                <div>
                                                    <Avatar sx={{
                                                        width: 24,
                                                        height: 24,
                                                    }}>{keycloak.tokenParsed.given_name.substring(0, 1)}</Avatar>
                                                </div>

                                                <IconButton
                                                    id="demo-positioned-button"
                                                    aria-controls={open ? "demo-positioned-menu" : undefined}
                                                    aria-haspopup="true"
                                                    aria-expanded={open ? "true" : undefined}
                                                    onClick={handleClick}>
                                                    Hi {keycloak.tokenParsed.given_name}
                                                </IconButton>
                                            </view>
                                        )}

                                        <view className="downArrowButtonCss">
                                            <IconButton
                                                data-testid="DropDownArrowButton"
                                                id="demo-positioned-button"
                                                style={{borderColor: "#0000FF", backgroundColor: "##0000FF",}}
                                                onClick={handleClick}
                                            >
                                                <ArrowDropDownIcon style={{color: "#000000"}}/>
                                            </IconButton>{" "}
                                        </view>

                                        <Menu
                                            id="demo-positioned-menu"
                                            aria-labelledby="demo-positioned-button"
                                            anchorEl={anchorEl}
                                            open={open}
                                            onClose={handleClose}
                                            anchorOrigin={{vertical: "top", horizontal: "left",}}
                                            transformOrigin={{vertical: "top", horizontal: "left",}}
                                        >
                                            <MenuItem onClick={handleClose} hidden={true}>Profile</MenuItem>
                                            <MenuItem onClick={handleClose} hidden={true}>My account</MenuItem>
                                            <MenuItem onClick={handleLogout}>Logout</MenuItem>

                                        </Menu>
                                    </div>
                                </div>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </div>
        </nav>
    );
};

export default Header;